import React from "react";
import { AlertTriangle } from "lucide-react";

export default function DisclaimerBanner({ text }) {
  return (
    <div
      role="note"
      className="w-full bg-[#E76F51]/10 border-l-4 border-[#E76F51] px-4 py-3 text-xs md:text-[13px] text-foreground/80 font-body flex items-start gap-3 rounded-r-sm"
      data-testid="disclaimer-banner"
    >
      <AlertTriangle size={16} className="text-[#E76F51] shrink-0 mt-0.5" />
      <span>{text}</span>
    </div>
  );
}
